import { View } from "@/components/ui/view";
import React from 'react';
import { FlatList } from "react-native-gesture-handler";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { useSelector } from "react-redux";
import Footer from "../../components/basic/Footer";
import WorkflowListElement from '../../components/workflow/WorkflowListElement';
import { switchScreen } from '../../hooks/navigate';

export default function SelectWorkflow({ navigation, route }) {
    const { startDate, contact } = route.params

    const insets = useSafeAreaInsets();
    const workflows = useSelector((state) => state.workflows)
    const pinned = useSelector((state) => state.settings.pinned || [])
    const data = Object.keys(workflows)
        .filter(taskid => taskid.length > 2 && !workflows[taskid].deleted && (!contact || workflows[taskid].owned))
        .map((taskid) => workflows[taskid])
        .sort((a, b) => {
            const aTitle = (a.title || '').toLowerCase()
            const bTitle = (b.title || '').toLowerCase()
            if (a.id.length == 1 && b.id.length == 1)
                return aTitle > bTitle ? 1 : aTitle < bTitle ? -1 : 0
            if (a.id.length == 1)
                return 1
            if (b.id.length == 1)
                return -1
            if (pinned.includes(a.id) && pinned.includes(b.id))
                return aTitle > bTitle ? 1 : aTitle < bTitle ? -1 : 0
            if (pinned.includes(a.id))
                return -1
            if (pinned.includes(b.id))
                return 1
            return aTitle > bTitle ? 1 : aTitle < bTitle ? -1 : 0
        })

    const onPress = (taskid) => {
        switchScreen(navigation, 'ScheduleWorkflow', { task: workflows[taskid], plans: [null], startDate: startDate, contact: contact })
    }

    const renderItem = ({ item, index }) => {
        return <WorkflowListElement navigation={navigation} taskid={item.id} showProgress={false} showTimer={false} onPress={onPress} icon={pinned.includes(item.id) ? 'push-pin' : null} />
    }

    return (
        <View className="bg-secondary-50 flex-1">
            <FlatList
                contentContainerStyle={{ paddingBottom: 70 + insets.bottom }}
                data={data}
                renderItem={renderItem}
                keyExtractor={item => item.id}
            />
            <Footer navigation={navigation} />
        </View>
    );
}
